import axios from 'axios';

import { apiEndpoints } from 'apiEndpoints';

// TODO probably wont be used
const postRecipientsValidity = async (file: File): Promise<void> => {
  const response = await axios.post(apiEndpoints.recipients.validity, file);
  return response.data;
};

const recipients = {
  postRecipientsValidity,
};

export default recipients;
